(function () {
  const productCards = document.querySelectorAll(
    ".section-products .product-item"
  );
  if (productCards) {
    productCards.forEach((el) => {
      const productUrl = el.querySelector(".product-info .product-title");
      if (productUrl) {
        const url = productUrl.getAttribute("href");

        const slideImages = el.querySelectorAll(".product-images a");
        if (slideImages) {
          slideImages.forEach((_el) => {
            _el.setAttribute("href", url);
          });
        }
      }
    });
  }

  const productImages = document.querySelectorAll(
    ".product-images .images-list"
  );

  if (productImages) {
    productImages.forEach((images) => {
      const imageSlider = new Splide(images, {
        type: "loop",
        pagination: true,
      }).mount();

      images.addEventListener("mouseenter", () => {
        imageSlider.go(1);
      });
      images.addEventListener("mouseleave", () => {
        imageSlider.go(0);
      });
    });
  }

  const sliderBlocks = document.querySelectorAll(
    ".slider-block .slider-block-slider"
  );
  if (sliderBlocks) {
    sliderBlocks.forEach((block) => {
      new Splide(block, {
        type: "loop",
        pagination: false,
      }).mount();
    });
  }

  const autoplayVid = document.querySelector(".section-video");
  if (autoplayVid) {
    const plyrConf = {
      muted: true,
      autopause: false,
      volume: 0,
      controls: ["play", "mute"],
      hideControls: false,
      loop: {
        active: true,
      },
    };
    const plyr = new Plyr("#video", plyrConf);
    plyr.on("ready", function () {
      player_desktop.embed.play();
    });
  }
})();
